import React, { createContext } from "react";

export const AccessCodeContext = React.createContext({});
